import React from 'react';
import CountUp from 'react-countup';

import {useInView} from 'react-intersection-observer';

import {motion} from 'framer-motion';

import {fadeIn} from '../variants'

const About = () => {
  const [ref,inView]=useInView({
    threshold:0.5,
  });

  return (
  <div id="About"  className="section mt-20" ref={ref}>
    <div className="container mx-auto">
      <div className="flex flex-col gap-y-10 lg:flex-row lg:item-center lg:gap-x-20 lg:gap-y-0 h-screen">
        <motion.div
        variants={fadeIn('right',0.5)} whileInView={'show'} viewport={{once:false,amount:0.7}}          className="flex-1 bg-about bg-contain w-screen bg-no-repeat h-[640px] mix-blend-lighten bg-top"></motion.div>
        <div className="flex-1">
          <motion.h2 
          variants={fadeIn('right',0.5)} initial="hidden" whileInView={'show'} viewport={{once:false,amount:0.7}}
          className="h2 text-accent">About me..</motion.h2>
          <h3 className="h3 mb-4">
            I am currently pursuing B.tech Information Technology in Chennai Institute of Technology. Currently experimenting the field of Web Development and the future plans include Machine learning andDdata Science as well.
          </h3>
          <p className="mb-6">
            The known programming languages include Python, C++. Also familiar with Python frameworks linke Numpy, Pandas, Matplotlib, Scikit and  Scipy.I have did internships on web development in two statup companies. I have also participated in various contests and hackathons that were held across various platforms like CodeForces, CodeChef, Leetcode, etc.
          </p>


          <div className="flex gap-x-6 lg:gap-x-10 mb-12">
            <div>
              <div className="text-[40px] font-tertiary text-gradient mb-2">
                {inView ? <CountUp start={100} end={2000} duration={3}/>:2000}+
                <div className="font-primary text-sm tracking-[2px]">Problems solved</div>
              </div>
            </div>

            <div>
              <div className="text-[40px] font-tertiary text-gradient mb-2">
                {inView ? <CountUp start={0} end={5} duration={3}/>:5}+
                <div className="font-primary text-sm tracking-[2px]">Projects</div>
              </div>
            </div>

            <div>
              <div className="text-[40px] font-tertiary text-gradient mb-2">
                {inView ? <CountUp start={0} end={2} duration={3}/>:5}
                <div className="font-primary text-sm tracking-[2px]">Internships</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  
  </div>);
};

export default About;
